export default __webpack_public_path__ + "static/media/gavel.9acf3a62.svg";